<template>
  <div class="full-container">
    <div class="row fh-cont no-margin">
      <div class="col-md-9 col-12 fh no-padding higher white">
        <div class="section-head white">
          <p>
            Showing Earnings for 
            <a id="v-home-step-1">
              {{ convertPeriodToText(this.period) }}
              <ul class="dpm">
                <li>
                  <router-link :to="{ name: 'getting-started-dashboard', query:{ period: 'today' }}">Today</router-link>
                  <router-link :to="{ name: 'getting-started-dashboard', query:{ period: 'week' }}">This Week</router-link>
                  <router-link :to="{ name: 'getting-started-dashboard', query:{ period: 'month' }}">This Month</router-link>
                  <router-link :to="{ name: 'getting-started-dashboard', query:{ period: '90' }}">Last 90 days</router-link>
                  <router-link :to="{ name: 'getting-started-dashboard', query:{ period: 'year' }}">This Year</router-link>
                  <router-link :to="{ name: 'getting-started-dashboard', query:{ period: 'all' }}">All Time</router-link>
                </li>
              </ul>
            </a>
          </p>
        </div>
        <div id="v-home-step-0">
          <div class="section-body row no-margin" v-if="doneLoading">
            <div class="col-12 metric">
              <h4>Earnings for {{ dashboardEarnings.date_range }}</h4>
              <h3><span>NGN</span> {{ dashboardEarnings.period_total }}</h3>
            </div>
            <div class="col-12 chart-holder">
              <revenue-chart :styles="{ height: '100%', position: 'relative'}" :chart-data="data" :options="options"></revenue-chart>
            </div>
          </div>
          <div class="section-body row no-margin justify-content-center py-6" v-else>
            <div class="col text-center">
              <broken-spinner color="#554971" :thickness="2" />
              
            </div>
          </div>
        </div>
        
        
      </div>
      <div class="col-3 hide-on-small-only darker no-padding">
        <div class="section-head darker" id="v-home-step-2">
          <p class="center-align">Tips</p>
        </div>
        <div class="section-body scrollabe" v-if="!loading.tips">
          <h4 class="center-align sub-head">
            <svg height="30px" viewBox="-82 0 512 512.00163" width="30px" xmlns="http://www.w3.org/2000/svg"><path d="m329.089844 94.824219c-1.921875-3.75-6.515625-5.230469-10.265625-3.3125-3.75 1.921875-5.234375 6.519531-3.3125 10.269531 11.523437 22.5 17.367187 46.820312 17.367187 72.285156 0 34.808594-11.054687 67.855469-31.96875 95.5625-8.675781 11.496094-13.453125 25.953125-13.453125 40.707032v.972656c0 20.777344-16.902343 37.679687-37.675781 37.679687h-68.085938v-96.597656c27.527344-3.738281 48.820313-27.382813 48.820313-55.917969 0-4.214844-3.417969-7.628906-7.628906-7.628906-4.214844 0-7.628907 3.414062-7.628907 7.628906 0 22.710938-18.476562 41.191406-41.191406 41.191406s-41.191406-18.480468-41.191406-41.191406c0-4.214844-3.414062-7.628906-7.628906-7.628906-4.210938 0-7.628906 3.414062-7.628906 7.628906 0 28.535156 21.292968 52.179688 48.820312 55.917969v96.597656h-68.085938c-20.773437 0-37.675781-16.902343-37.675781-37.679687v-.984375c0-14.839844-4.816406-29.128907-13.929687-41.324219-20.273438-27.144531-31.160156-59.441406-31.484375-93.394531-.402344-42.5 15.941406-82.65625 46.015625-113.074219 30.066406-30.40625 70.015625-47.195312 112.492187-47.273438h.300781c49.964844 0 96.007813 22.804688 126.355469 62.601563 2.558594 3.347656 7.34375 3.992187 10.691407 1.4375 3.351562-2.554687 3.996093-7.339844 1.441406-10.6875-15.933594-20.898437-36.722656-38.191406-60.117188-50.007813-24.539062-12.394531-51.058594-18.6718745-78.699218-18.601562-46.574219.0859375-90.367188 18.484375-123.3125 51.800781-32.957032 33.332031-50.863282 77.351563-50.4218755 123.949219.3554685 37.21875 12.2890625 72.621094 34.5195315 102.378906 7.125 9.539063 10.890625 20.671875 10.890625 32.195313v.984375c0 16.269531 7.382812 30.839844 18.964843 40.558594-11.171874 5.074218-18.964843 16.328124-18.964843 29.375 0 14.832031 10.070312 27.351562 23.726562 31.101562-3.539062 5.175781-5.609375 11.425781-5.609375 18.152344 0 17.785156 14.46875 32.253906 32.253906 32.253906h21.652344c3.742188 27.769531 27.578125 49.25 56.355469 49.25s52.613281-21.484375 56.351563-49.25h21.652343c17.785157 0 32.253907-14.46875 32.253907-32.253906 0-6.726563-2.070313-12.976563-5.605469-18.152344 13.65625-3.75 23.722656-16.269531 23.722656-31.101562 0-12.910157-7.628906-24.066407-18.609375-29.214844 11.691406-9.71875 19.152344-24.359375 19.152344-40.714844v-.972656c0-11.460938 3.683594-22.652344 10.371094-31.519532 22.925781-30.375 35.046874-66.601562 35.046874-104.75 0-27.910156-6.40625-54.570312-19.042968-79.246093zm-155.292969 401.921875c-20.347656 0-37.316406-14.679688-40.910156-33.996094h81.820312c-3.59375 19.316406-20.566406 33.996094-40.910156 33.996094zm96.121094-132.5c9.375 0 17 7.625 17 16.996094 0 9.375-7.625 17-17 17h-132.792969c-4.210938 0-7.628906 3.414062-7.628906 7.625 0 4.214843 3.417968 7.628906 7.628906 7.628906h114.675781c9.375 0 17 7.625 17 17 0 9.371094-7.625 16.996094-17 16.996094h-156.011719c-9.371093 0-16.996093-7.625-16.996093-16.996094 0-9.375 7.625-17 16.996093-17h10.824219c4.210938 0 7.625-3.414063 7.625-7.628906 0-4.210938-3.414062-7.625-7.625-7.625h-28.941406c-9.371094 0-16.996094-7.628907-16.996094-17 0-9.375 7.625-16.996094 16.996094-16.996094zm0 0" fill="#818181" /></svg>
          </h4>
          <ul class="nice-list">
            <li v-for="tip of tips" :key="tip.id">
              <a @click="makeTipActive(tip)">{{ tip.title }}</a>
            </li>
          </ul>
        </div>
        <div class="section-body row no-margin justify-content-center py-3" v-else>
          <div class="col text-center">
            <broken-spinner color="#554971" :thickness="2" />
          </div>
        </div>
        <div class="section-head darker">
          <p class="center-align">Statistics</p>
        </div>
        <div class="section-body" v-if="doneLoading"></div>
        <div class="section-body row no-margin justify-content-center py-3" v-else>
          <div class="col text-center">
            <broken-spinner color="#554971" :thickness="2" />
          </div>
        </div>
      </div>
    </div>
    <b-modal ref="myModalRef" hide-footer centered class="mkmodal" :title="activeTip.title">
      <div class="d-block text-center" v-html="activeTip.content">
      </div>
    </b-modal>
    <v-tour name="homeTour" :steps="steps" :options="tourOptions" :callbacks="callbacks"></v-tour>
  </div>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert';
import BrokenSpinner from '@/components/Preloaders/BrokenSpinner';
import RevenueChart from './partials/js/RevenueChart';

export default {
  name: 'home',
  props: {
    period: String,
    default: 'today',
  },
  components: { RevenueChart, BrokenSpinner },
  beforeRouteEnter(to, from, next) {
    next(vm => vm.$store.commit('OFF_VISIBILITY'));
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            gridLines: {
              drawBorder: false,
              drawTicks: true,
              zeroLineWidth: 0,
              zeroLineColor: 'rgba(150, 150, 150, 0.1)',
              color: 'rgba(100, 100, 100, 0.1)',
            },
            ticks: {
              beginAtZero: true,
              fontColor: '#818181',
              maxTicksLimit: 7,
            },
          }],
          xAxes: [{
            gridLines: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              fontColor: '#818181',
            },
            barPercentage: 1.2,
          }],
        },
        tooltips: {
          enabled: true,
          displayColors: false,
        },
        legend: {
          display: false,
        },
      },
      doneLoading: false,
      loading: {
        tips: true,
      },
      tips: [],
      activeTip: {
        title: 'dd',
        content: 'dd',
      },
      steps: [
        {
          target: '#v-home-step-0', // We're using document.querySelector() under the hood
          content: 'View a graph of your earnings',
          params: {
            placement: 'bottom',
          },
        },
        {
          target: '#v-home-step-1', // We're using document.querySelector() under the hood
          content: 'Filter the graph based on the period of interest.',
        },
        {
          target: '#v-home-step-2', // We're using document.querySelector() under the hood
          content: 'Get tips on how to become a more successful tutor at prepclass.',
          params: {
            placement: 'top',
          },
        },
      ],
      tourOptions: {
        useKeyboardNavigation: true,
        labels: {
          buttonSkip: 'Skip',
          buttonPrevious: 'Previous',
          buttonNext: 'Next',
          buttonStop: 'Next ⨠',
        },
      },
      callbacks: {
        onStop: this.doneTour,
      },
    };
  },
  computed: {
    data() {
      return {
        labels: this.$store.getters.dashboard_earnings.x,
        datasets: [{
          label: 'NGN',
          data: this.$store.getters.dashboard_earnings.y,
          hoverBackgroundColor: 'rgba(99, 148, 64, 0.35)',
          backgroundColor: 'rgba(99, 148, 64, 0.25)',
          borderColor: 'rgba(99, 148, 64, .07)',
          borderWidth: 2,
        }],
      };
    },
    dashboardEarnings() {
      return this.$store.getters.dashboard_earnings;
    },
  },
  methods: {
    convertPeriodToText(t) {
      switch (t) {
        case 'today':
          return 'This Day';
        case 'week':
          return 'This Week';
        case 'month':
          return 'This Month';
        case '90':
          return 'Last 90 days';
        case 'year':
          return 'This Year';
        case 'all':
          return 'All Time';
        default:
          return 'This Month';
      }
    },
    getDashboardEarnings(period) {
      this.$store.dispatch('getDashboardEarnings', period)
        .then(() => {
          this.doneLoading = true;
        })
        .catch((error) => {
          this.doneLoading = true;
        });
    },
    getTips() {
      return new Promise((resolve, reject) => {
        axios.get(`${BASE_API}/v1/tutor/profile/tips`)
          .then(({ data: { data } }) => {
            this.$set(this.loading, 'tips', false);
            this.tips = data;
            resolve();
          })
          .catch((error) => {
            const data = error.response || {message: 'Opperation failed'};
            swal('Error', data.message, 'error');
            this.$set(this.loading, 'tips', false);
            reject(data.message);
          });
      });
    },
    makeTipActive(tip) {
      this.activeTip = tip;
      this.$refs.myModalRef.show();
    },
    doneTour() {
      return new Promise((resolve, reject) => {
        axios.post(`${BASE_API}/v1/tutor/tours`, { tour: 'home' })
          .then(() => {
            this.$auth.fetch();
            this.$store.dispatch('getUserTutor');
            this.$router.push({ name: '' });
            resolve();
          })
          .catch(error => reject(error.response));
      });
    },
  },
  mounted() {
    let { period } = this;

    if (typeof period === 'undefined') {
      period = 'month';
    }
    this.getDashboardEarnings(period);
    this.getTips();

    if (!(this.$auth.user().tours && this.$auth.user().tours.home)) {
      this.$tours['homeTour'].start();
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.doneLoading = false;
    this.getDashboardEarnings(to.query.period);
    next();
  },
};
</script>

<style lang="scss" scoped>
  .text-align-center {
    text-align: center;
  }
  .full-container {
    width: 100%;
    min-height: calc(100% - 70px);
  }
  .fh-cont {
    height: 100%;
  }
  .section-head {
    position: relative;
    padding: 15px 30px;
    border-bottom: solid 1px rgba(0,0,0,.05);
    height: 70px;
    clear: both;
    p {
      font-size: 14px;
      line-height: 40px;
      color: #576271;
      a {
        position: relative;
        cursor: pointer;
        font-weight: 700;
        &:hover > .dpm {
          display: block;
        }
      }
    }
  }
  .section-body {
    padding: 15px 30px;
    clear: both;
  }
  .metric {
    padding: 6px;
    text-align: center;
    color: #576271;
    h4 {
      font-size: 17px;
      margin: 10px;
    }
    h3 {
      font-size: 28px;
      font-weight: 700;
      margin-bottom: 10px;
      span {font-weight: 300;}
    }
  }
  .sub-head {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #576271;
    font-weight: 400;
    svg { margin: 0 7px; }
  }
  .nice-list {
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    list-style-image: url(./partials/crown.svg);

    li {
      padding: 5px;
      color: #576271;
      &>a {
        color: #576271;
        font-size: 13px;
        cursor: pointer;
        text-transform: capitalize;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
  .chart-holder {
    padding: 15px 0;
    box-sizing: border-box;
    height: 300px;
  }
  .fh {
    height: 100%;
  }
  .no-margin {
    margin: 0 !important;
  }
  .higher {
    box-shadow: 1px 0 2px rgba(0,0,0,.05);
  }
  .no-padding {
    padding: 0 !important;
  }
  .white {
    background-color: #fff;
  }
  .center-align {
    text-align: center;
  }
  .darker {
    background-color: #fafafa;
  }
  .py-6 {
    padding: 6rem 0;
  }
  .py-3 {
    padding: 3rem 0;
  }
  .dpm {
    position: absolute;
    top: calc(100% + 7px);
    left: -50%;
    z-index: 1000;
    float: left;
    display: none;
    min-width: 145px;
    padding: 5px 0;
    margin: 0px 0 0;
    list-style: none;
    font-size: 14px;
    text-align: left;
    background-color: #fff;
    border-radius: 3px;
    box-shadow: 0 6px 12px rgba(150, 150, 150, .175);
    background-clip: padding-box;
    transition: all .3s ease-in-out;
    &:after {
      content: "";
      position: absolute;
      display: block;
      width: 37px;
      height: 12px;
      top: -12px;
      left: 0;
      right: 0;
      margin: 0 auto;
      background-image: url(../../../assets/dropdown_arrow.png);
      background-size: 100% 100%;
    }
    li>a {
      padding: 5px 15px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      clear: both;
      font-weight: 400;
      line-height: 1.42857143;
      color: #576271;
      text-decoration: none;
      white-space: nowrap;
      margin: 5px 0;
    }
    li>a:hover {
      background-image: none;
      filter: none;
      background-color: rgba(2, 17, 27, 0.05);
      color: #576271;
    }
    li>a>svg {
      margin-right: 7px;
    }
    li>hr {
      margin: 10px 0;
    }
  }
</style>

<style lang="scss">
.mkmodal {
  .labels {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    font-size: 12px;
    padding: 15px;
    p {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin: 0;
      margin-right: 10px;
    }
    span {
      content: '';
      display: block;
      height: 12px;
      width: 12px;
      border-radius: 100%;
      margin-right: 10px;
    }
  }
  .modal-backdrop {
    opacity: 1;
    background-color: #E2E8ED;
    filter: blur(9px) brightness(50) opacity(50%);
  }
  .modal-content {
    border: none;
    box-shadow: 5px 5px 30px rgba(0, 0, 0, 0.08);
    border-radius: 6px;
    .modal-header {
      justify-content: center;
      position: relative;
      border-bottom: none;
      .modal-title {
        text-align: center;
      }
      .close {
        float: right;
        right: 0;
        top: 0;
        margin: 0;
        position: absolute;
      }
    }
    .modal-body {
      width: 85%;
      margin-left: auto;
      margin-right: auto;
      .form-control {
        border-radius: 4px;
        border: 1px solid #E8E9EC;
        padding: 5px 15px; 
        color: #4D4F5C;
        &::placeholder {color: #4D4F5C; opacity: 0.3;}
      }
      select.form-control {
        option {
          padding: 10px;
        }
      }
      .quillWrapper {
        .ql-toolbar.ql-snow {
          border: 1px solid #E8E9EC;
          border-top-right-radius: 4px;
          border-top-left-radius: 4px;
          text-align: left;
          padding: 4px 15px;
          .ql-formats {
            margin: 0;
          }
          .ql-picker-label {
            font-size: 13px;
          }
          button {
            svg {height: 16px; width: 16px}
          }
        }
        .ql-container.ql-snow {
          border: 1px solid #E8E9EC;
          border-bottom-left-radius: 4px;
          border-bottom-right-radius: 4px;
          border-top: none;
        }

      }
      .btn {
        width: 130px;
        height: 38px;
        line-height: 38px;
        padding: 0 10px;
        text-align: center;
        border-radius: 4px;
        font-size: 14px;
        vertical-align: middle;
        box-shadow: 0 2px 2px 0 rgba(40, 167, 69, 0.14), 0 3px 1px -2px rgba(40, 167, 69, 0.12), 0 1px 5px 0 rgba(40, 167, 69, 0.2);
        &:focus {
          outline: 0 !important;
          box-shadow: none !important;
          &:active {box-shadow: none !important;}
        }
      }
      .c-pane-container {
        width: 100%;
        margin-top: 0px;
        margin-bottom: 20px;
        border: none !important;
        background-color: #ffffff !important;

        .c-header {
          padding: 15px 10px;
          padding-bottom: 35px;
          .c-arrow-layout {
            padding: 10px;
            border: 1px solid #E8E9EC;
            box-shadow: 0 2px 3px rgba(0, 0, 0, 0.05);
            border-radius: 4px;
          }
          .c-title {
            font-size: 14px;
            color: #639440;
          }
        }
        .c-weekdays {
          .c-weekday {
            padding: 15px;
            font-size: 12px;
            font-weight: 600;
            background-color: rgba(221, 232, 213, 1);
          }
        }
        .c-week {
          .c-day-content {
            padding: 15px;
            font-size: 11px;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Pages/Dashboard/Home.vue